// extracted by mini-css-extract-plugin
export default {"Opps":"opps_Opps__DVpL7","OppsButton":"opps_OppsButton__AbZvd","text":"opps_text__gykS7"};